import { render, staticRenderFns } from "./SwiperCarousel.vue?vue&type=template&id=3e1a8a98&"
import script from "./SwiperCarousel.vue?vue&type=script&lang=js&"
export * from "./SwiperCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports